// extracted by mini-css-extract-plugin
export default {"dropdownMenuCellOverlay":"Dropdown_dropdownMenuCellOverlay__-6Szl"};